import * as React from "react"
import Logo from '../images/logo.png';
import App1 from '../images/app-screenshots/6.5 - 1.png';
import App2 from '../images/app-screenshots/6.5 - 2.png';
import App3 from '../images/app-screenshots/6.5 - 3.png';
import App4 from '../images/app-screenshots/6.5 - 4.png';
import App5 from '../images/app-screenshots/6.5 - 5.png';
import Og from '../images/dotastatz-og.png';
import AppStore from '../images/appstore.png';
import PlayStore from '../images/playstore.png';
import Discord from '../images/discord.png';

import 'bootstrap/dist/css/bootstrap.min.css';
import Footer from "../components/Footer";
import { Helmet } from "react-helmet";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const IndexPage = () => {

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    // slidesToScroll: 5,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.25,
          // slidesToScroll: 1,
          infinite: false,
          dots: false
        }
      },
    ]
  };

  return (
    <main>
      <Helmet>
        <meta charSet="utf-8" />

        <title>Dotastatz - Dota 2 Statistics Mobile App</title>
        <meta name="description" content="Dotastatz is a fan made application that allows Dota 2 players to find and track their profile easily without logging in. The app will keep you up to date on all the important tournaments, team ranking and many more." />
          
        <meta property="og:title" content="Dotastatz - Dota 2 Statistics Mobile App"/>
        <meta property="og:description" content="Dotastatz is a fan made application that allows Dota 2 players to find and track their profile easily without logging in. The app will keep you up to date on all the important tournaments, team ranking and many more."/>
        <meta property="og:site_name" content="dotastats.app"/>
        <meta property="og:url" content="https://dotastats.app/"/>
        <meta property="og:image" content={Og}/>

        <meta name="twitter:title" content="Dotastatz - Dota 2 Statistics Mobile App"/>
        <meta name="twitter:description" content="Dotastatz is a fan made application that allows Dota 2 players to find and track their profile easily without logging in. The app will keep you up to date on all the important tournaments, team ranking and many more."/>
        <meta name="twitter:card" content="summary_large_image"/>
        <meta name="twitter:image" content={Og}></meta>

        <link rel="icon" type="image/png" href={Logo}/>
      </Helmet>
      <div className="content">
        <div className="">
          <div className="logo-container mx-auto mb-3">
              <img src={Logo} alt="DotaStats logo" className="w-100 h-100"></img>
          </div>
          <div className="text-center">
            <h1 className="title">Dota<span className="text-main">statz</span></h1>
            <p className="description mb-2">The most comprehensive Dota 2 statistics mobile application.</p>
            <div className="row text-center w-full m-auto justify-content-center align-items-center pb-5">
              <a href="https://apps.apple.com/us/app/dotastatz/id1563611951" className="download-icon">
                <img src={AppStore} alt="dotastats app store" className="w-100 h-100"/>
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.dotastat" className="download-icon">
                <img src={PlayStore} alt="dotastats play store" className="w-100 h-100"/>
              </a>
              <a href="https://discord.gg/9TYHnJQf" className="download-icon">
                <img src={Discord} alt="discord dotastatz" className="w-100 h-100"/>
              </a>
              {/* <a href="https://www.producthunt.com/posts/dotastatz?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-dotastatz" target="_blank"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=294318&theme=dark" alt="Dotastatz - A statistics mobile application for Dota 2 players | Product Hunt" style={{width: 250, height: 54}} width="250" height="54" /></a> */}
            </div>
          </div>
          <Slider {...settings}>
            <div className="px-2">
              <img src={App1} alt="dotastats-app-1" className="w-100 h-100"/>
            </div>
            <div className="px-2">
              <img src={App2} alt="dotastats-app-2" className="w-100 h-100"/>
            </div>
            <div className="px-2">
              <img src={App3} alt="dotastats-app-3" className="w-100 h-100"/>
            </div>
            <div className="px-2">
              <img src={App4} alt="dotastats-app-4" className="w-100 h-100"/>
            </div>
            <div className="px-2">
              <img src={App5} alt="dotastats-app-5" className="w-100 h-100"/>
            </div>
          </Slider>
        </div>
        <Footer showNav/>
      </div>
    </main>
  )
}

export default IndexPage
